import styled from 'styled-components';
import { PointTheme } from '@chkp/point.core.point-theme';

// The provider's wrapper div paints a surface over the #app mesh and adds a layout box;
// `contents` drops both while its custom properties still inherit.
export const Root = styled(PointTheme)`
  display: contents;
`;
